import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssestsLinkComponent } from './assests-link/assests-link.component';
import { AssestsLandingPageComponent } from './assests-landing-page/assests-landing-page.component';


const routes: Routes = [
  {
    path: '', component: AssestsLinkComponent,
    children: [
      {
        path: 'assetQREntry', component: AssestsLandingPageComponent
      },  
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssestsRoutingModule { }
